import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { RtcDownloaderComponent } from '../rtc-downloader/rtc-downloader.component';
import { RtcUploaderComponent } from '../rtc-uploader/rtc-uploader.component';
import { DrawingUploaderComponent } from '../drawing-uploader/drawing-uploader.component';
import { DrawingDownloaderComponent } from '../drawing-downloader/drawing-downloader.component';
import { DrawingDeleteComponent } from '../drawing-delete/drawing-delete.component';
import { HelpDocComponent } from '../help-doc/help-doc.component';

export const routes: Routes = [
  {
    path: 'rtcdownload', component: RtcDownloaderComponent,pathMatch: 'full'
  },
  {
    path:'rtcupload', component: RtcUploaderComponent, pathMatch: 'full'
  },
  {
    path:'drawdownload', component: DrawingDownloaderComponent, pathMatch: 'full'
  },
  {
    path:'drawupload', component: DrawingUploaderComponent, pathMatch: 'full'
  },
  {
    path:'drawdelete', component: DrawingDeleteComponent, pathMatch: 'full'
  },
  {
    path:'help', component: HelpDocComponent, pathMatch: 'full'
  },
  { 
    path: '', redirectTo: 'rtcdownload', pathMatch: 'full' 
  }
];
@NgModule({
  imports: [BrowserModule, FormsModule, RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class RoutingModule { }
